var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.9 13.35a8.98 8.98 0 01-1.157-.366l-.007.006-3.023-1.187a.324.324 0 00-.046-.013V2h8.202c3.063 0 5.544 2.5 5.544 5.589a5.596 5.596 0 01-2.481 4.661l-1.892.747a8.597 8.597 0 01-3.149.594 8.24 8.24 0 01-.8-.04 10.76 10.76 0 01-.794-.114 8.5 8.5 0 01-.397-.086zm4.981-5.315c0-1.58-1.27-2.86-2.838-2.86-1.567 0-2.837 1.28-2.837 2.86 0 1.58 1.27 2.861 2.838 2.861 1.567 0 2.837-1.28 2.837-2.86zM6.83 22H4.667v-8.936l3.208 2.24L6.83 22zm7.065-6.695L14.946 22H20l-3.565-8.47-2.54 1.775zM8.715 22l.853-1.48a1.52 1.52 0 012.64 0L13.06 22H8.715z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsFill);
export default __webpack_public_path__ + "96925413653c9416c970d38cefa79b63.svg";
export { ForwardRef as ReactComponent };